import React from "react";

const stories = [
  {
    title: "Génération de leads qualifiés",
    subtitle: "Campagne LinkedIn pour une startup SaaS",
    image: "/images/portfolio/portfolio-01/image-01.jpg",
  },
  {
    title: "Recrutement de talents tech",
    subtitle: "Stratégie de marque employeur",
    image: "/images/portfolio/portfolio-01/image-02.jpg",
  },
  {
    title: "Création de notoriété",
    subtitle: "Personal branding pour un CEO",
    image: "/images/portfolio/portfolio-01/image-03.jpg",
  },
];

const CustomerStoriesSection = () => {
  return (
    <section className="bg-gray-50 py-20">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-primary text-lg font-semibold mb-2 block">Cas clients</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Ils ont boosté leur visibilité</h2>
          <p className="text-gray-600 mt-4">
            Découvrez comment nos clients ont transformé leur stratégie LinkedIn grâce à notre accompagnement personnalisé.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {stories.map((story, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition">
              <img src={story.image} alt={story.title} className="w-full h-56 object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800">{story.title}</h3>
                <p className="text-sm text-gray-600 mt-2">{story.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerStoriesSection;
